export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9977_EXPAND': 'Expand',
    '_9978_COLLAPSE': 'Collapse',
    '_763_CLOSE': 'Close',
    '__SEE_FULL_RESULTS': 'See Full Results',
    '__COLLAPSE_RESULTS': 'Collapse Results',
    '__CREATE_NOTES': 'Create Notes'
};
